import { getTranslations, getTranslationsMessages } from '../boot/i18n'
import { getFlatObject, matchExact } from './transformers'

/**
 * Helper class to shorten translation key lookup
 * eg:- routes
 * {
      path: 'route/path',
      component: ....,
      name: 'Route Name',
      meta: {
        title: 'modules.sales.salesManagement.abc.123.def.ghi.title' // original translation key
        title: '@ghi.title'                                          // shorten translation key with `@` identifier
        ...
      },
    },
 * Routes identifier replacement happens at `src/router` -> updateRoutesTranslations function
 *
 * @param key
 * @returns {Promise<string|string>}
 */
export async function preTranslator(key) {
  let translations = await getTranslations()
  return execute(translations, key)
}

/**
 * Helper class to shorten translation key lookup without promise
 *
 *  * eg:- .vue files
 * Using global function `translationShortener(key)` will return translated string
 *  <div>
 *    <q-input :label="translationShortener('sale.input.label')" ...>
 *      ....
 *    </q-input>
 *
 *    -- OR --
 *
 *    <div> {{ translationShortener('sale.notification.message') }} </div>
 *  </div>
 * @param key
 * @returns {string|string}
 */
export function postTranslator(key) {
  let translations = getTranslationsMessages()
  return execute(translations, key)
}

function execute(translations, key) {
  let flatObject = getFlatObject(translations)
  let keyPath = Object.keys(flatObject).find(function(path) {
    return matchExact(key, path)
  })
  return keyPath || 'common.words.getTranslateKeyFailed'
}
